import {
  AddressWithCopy,
  MockLoadingTable,
  Token,
} from '@/components/molecules'
import { timestampToDate, toUTC } from '@/utils'
import { CheckCircleIcon, InfoIcon } from '@chakra-ui/icons'
import {
  HStack,
  Table,
  TableContainer,
  Tag,
  TagLabel,
  TagLeftIcon,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useAccount, usePublicClient } from 'wagmi'

export const RequestsTable = ({ requests, isLoading }) => {
  const { chain } = useAccount()
  const client = usePublicClient()
  const [requestTimes, setRequestTimes] = useState({})
  const blockExplorerUrl = chain?.blockExplorers?.default?.url

  useEffect(() => {
    if (!requests?.length) return

    requests.forEach(async (event) => {
      const block = await client.getBlock({ blockNumber: event.block })
      const date = new Date(timestampToDate(block.timestamp))
      const utcTime = toUTC(date)

      setRequestTimes((prev) => ({ ...prev, [event.block]: utcTime }))
    })
  }, [requests, client])

  return (
    <>
      {isLoading ? (
        <MockLoadingTable
          headers={[
            'Time',
            'Consumer',
            'Transaction Hash',
            'Status',
            'Spent (FTN)',
          ]}
        />
      ) : (
        <>
          {!requests?.length ? (
            <Text>No Requests found</Text>
          ) : (
            <TableContainer>
              <Table fontSize={14} size={['sm', 'md']}>
                <Thead>
                  <Tr>
                    <Th>Time</Th>
                    <Th>Consumer</Th>
                    <Th>Transaction Hash</Th>
                    <Th>Status</Th>
                    <Th>Spent (FTN)</Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {requests?.map(
                    (
                      { block, consumer, transactionHash, isFulfilled, spent },
                      idx,
                    ) => (
                      <Tr key={idx}>
                        <Td>
                          <VStack alignItems={'flex-start'} spacing={0.5}>
                            <Text fontSize={'smaller'}>
                              {requestTimes[block]}
                            </Text>

                            <HStack spacing={0}>
                              <Text>Block #</Text>
                              <AddressWithCopy
                                to={`${blockExplorerUrl}/block/${block}`}
                                address={block}
                                fullAddress={true}
                              />
                            </HStack>
                          </VStack>
                        </Td>
                        <Td>
                          <AddressWithCopy address={consumer} symbols={5} />
                        </Td>
                        <Td>
                          <AddressWithCopy
                            to={`${blockExplorerUrl}/tx/${transactionHash}`}
                            address={transactionHash}
                            symbols={5}
                          />
                        </Td>
                        <Td>
                          {isFulfilled ? (
                            <Tag size={'md'} key={idx} colorScheme="green">
                              <TagLeftIcon
                                boxSize={'12px'}
                                as={CheckCircleIcon}
                              />
                              <TagLabel>Success</TagLabel>
                            </Tag>
                          ) : (
                            <Tag size={'md'} key={idx} colorScheme="red">
                              <TagLeftIcon boxSize={'12px'} as={InfoIcon} />
                              <TagLabel>Pending</TagLabel>
                            </Tag>
                          )}
                        </Td>
                        <Td>
                          <Token amount={spent} decimal={5} symbol={'FTN'} />
                        </Td>
                      </Tr>
                    ),
                  )}
                </Tbody>
              </Table>
            </TableContainer>
          )}
        </>
      )}
    </>
  )
}
